function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8.094 6.809l4.96 4.98a.698.698 0 0 1 .235.537.744.744 0 0 1-.225.547.744.744 0 0 1-.546.225.698.698 0 0 1-.538-.235L7 7.883l-4.98 4.98a.698.698 0 0 1-.538.235.744.744 0 0 1-.546-.225.744.744 0 0 1-.225-.547c0-.215.078-.394.234-.537l4.961-4.98-4.96-4.98A.698.698 0 0 1 .71 1.29c0-.215.075-.397.225-.547A.744.744 0 0 1 1.482.52c.215 0 .394.078.538.234L7 5.714l4.98-4.96a.698.698 0 0 1 .538-.234c.214 0 .397.074.546.224.15.15.225.332.225.547a.698.698 0 0 1-.234.537l-4.961 4.98z"
});

const SvgClose = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.bda362bd.svg";
export { ForwardRef as ReactComponent };